import React, { useState, useEffect } from 'react';
import { LoadingSpinner, Modal } from '../components/shared';

// ─── ICONE FILE SVG ───────────────────────────────────────────────────────────
function FileIcon({ ext, size = 36 }) {
  const e = (ext||'').toLowerCase();
  const configs = {
    pdf:  { bg:'#E53E3E', label:'PDF',  icon:'📋' },
    doc:  { bg:'#2B579A', label:'DOC',  icon:'📝' },
    docx: { bg:'#2B579A', label:'DOCX', icon:'📝' },
    xls:  { bg:'#217346', label:'XLS',  icon:'📊' },
    xlsx: { bg:'#217346', label:'XLSX', icon:'📊' },
    csv:  { bg:'#217346', label:'CSV',  icon:'📊' },
    ppt:  { bg:'#D24726', label:'PPT',  icon:'📑' },
    pptx: { bg:'#D24726', label:'PPTX', icon:'📑' },
    jpg:  { bg:'#805AD5', label:'JPG',  icon:'🖼' },
    jpeg: { bg:'#805AD5', label:'JPEG', icon:'🖼' },
    png:  { bg:'#6B46C1', label:'PNG',  icon:'🖼' },
    gif:  { bg:'#9F7AEA', label:'GIF',  icon:'🖼' },
    webp: { bg:'#7C3AED', label:'WEBP', icon:'🖼' },
    zip:  { bg:'#B7791F', label:'ZIP',  icon:'🗜' },
    rar:  { bg:'#B7791F', label:'RAR',  icon:'🗜' },
    txt:  { bg:'#4A5568', label:'TXT',  icon:'📄' },
    msg:  { bg:'#0072C6', label:'MSG',  icon:'✉' },
    eml:  { bg:'#0072C6', label:'EML',  icon:'✉' },
  };
  const cfg = configs[e] || { bg:'#718096', label:(e||'FILE').toUpperCase().slice(0,4), icon:'📎' };

  return (
    <div style={{
      width: size, height: size, borderRadius: 6, flexShrink: 0,
      background: cfg.bg,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    }}>
      <div style={{ fontSize: size * 0.42, lineHeight: 1 }}>{cfg.icon}</div>
      <div style={{ fontSize: size * 0.22, color: 'white', fontWeight: 700,
        letterSpacing: '0.3px', marginTop: 1 }}>{cfg.label}</div>
    </div>
  );
}

// ─── MODAL ANTEPRIMA ─────────────────────────────────────────────────────────
function PreviewModal({ file, onClose }) {
  const ext  = (file.nome.split('.').pop()||'').toLowerCase();
  const url  = file.url;
  const isImg  = ['jpg','jpeg','png','gif','webp','svg'].includes(ext);
  const isPdf  = ext === 'pdf';
  const isText = ['txt','csv','log','md'].includes(ext);
  const [text, setText] = useState('');

  useEffect(() => {
    if (isText) {
      fetch(url).then(r=>r.text()).then(setText).catch(()=>setText('Impossibile leggere il file'));
    }
  }, [url, isText]);

  return (
    <div className="modal-backdrop" onClick={e => { if(e.target===e.currentTarget) onClose(); }}>
      <div style={{
        background: 'var(--surface)', borderRadius: 'var(--radius)',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        display: 'flex', flexDirection: 'column',
        width: '90vw', height: '90vh', maxWidth: 1100,
        overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 18px',
          borderBottom:'1px solid var(--border)', flexShrink:0 }}>
          <FileIcon ext={ext} size={32} />
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontWeight:600, fontSize:14, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
              {file.nome}
            </div>
            {file.data && <div style={{ fontSize:11, color:'var(--text-faint)' }}>{file.data}</div>}
          </div>
          <a href={url} download={file.nome}
            className="btn btn-sm" style={{ flexShrink:0 }}>⬇ Scarica</a>
          <a href={url} target="_blank" rel="noreferrer"
            className="btn btn-sm" style={{ flexShrink:0 }}>↗ Apri</a>
          <button onClick={onClose}
            style={{ border:'none', background:'none', fontSize:22, cursor:'pointer',
              color:'var(--text-faint)', lineHeight:1, padding:'0 4px' }}>×</button>
        </div>

        {/* Contenuto */}
        <div style={{ flex:1, overflow:'hidden', background:'#f0f0f0' }}>
          {isPdf && (
            <iframe src={url} style={{ width:'100%', height:'100%', border:'none' }}
              title={file.nome} />
          )}
          {isImg && (
            <div style={{ width:'100%', height:'100%', display:'flex',
              alignItems:'center', justifyContent:'center', padding:20 }}>
              <img src={url} alt={file.nome}
                style={{ maxWidth:'100%', maxHeight:'100%', objectFit:'contain',
                  boxShadow:'0 4px 20px rgba(0,0,0,0.2)', borderRadius:4 }} />
            </div>
          )}
          {isText && (
            <div style={{ width:'100%', height:'100%', overflow:'auto', padding:20 }}>
              <pre style={{ fontFamily:'monospace', fontSize:13, color:'#1a1a1a',
                background:'white', padding:16, borderRadius:6,
                whiteSpace:'pre-wrap', wordBreak:'break-word' }}>{text}</pre>
            </div>
          )}
          {!isPdf && !isImg && !isText && (
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center',
              justifyContent:'center', height:'100%', gap:16 }}>
              <FileIcon ext={ext} size={72} />
              <div style={{ fontSize:14, color:'#555' }}>
                Anteprima non disponibile per i file .{ext}
              </div>
              <div style={{ display:'flex', gap:10 }}>
                <a href={url} download={file.nome} className="btn btn-primary">⬇ Scarica file</a>
                <a href={url} target="_blank" rel="noreferrer" className="btn">↗ Apri in nuova scheda</a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── CARD FILE ────────────────────────────────────────────────────────────────
function FileCard({ f, isSel, onToggle, onPreview }) {
  const ext = (f.nome.split('.').pop()||'').toLowerCase();
  return (
    <div style={{
      display:'flex', flexDirection:'column', gap:8,
      padding:'10px', width:130,
      background: isSel ? 'var(--accent-light)' : 'var(--bg)',
      border: `1.5px solid ${isSel ? 'var(--accent)' : 'var(--border)'}`,
      borderRadius:'var(--radius-sm)', cursor:'pointer',
      transition:'all 0.12s', position:'relative',
    }}>
      {/* Checkbox */}
      <input type="checkbox" checked={isSel} onChange={onToggle}
        onClick={e => e.stopPropagation()}
        style={{ position:'absolute', top:6, right:6,
          accentColor:'var(--accent)', cursor:'pointer', width:14, height:14 }} />

      {/* Icona — click apre anteprima */}
      <div style={{ display:'flex', justifyContent:'center', paddingTop:4 }}
        onClick={onPreview}>
        <FileIcon ext={ext} size={44} />
      </div>

      {/* Nome */}
      <div style={{ fontSize:11, fontWeight:500, textAlign:'center', wordBreak:'break-word',
        lineHeight:1.3, color: isSel ? 'var(--accent)' : 'var(--text)',
        display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}
        title={f.nome} onClick={onPreview}>
        {f.nome}
      </div>

      {f.data && (
        <div style={{ fontSize:10, color:'var(--text-faint)', textAlign:'center' }}>{f.data}</div>
      )}
    </div>
  );
}

// ─── MAIN PAGE ────────────────────────────────────────────────────────────────
export default function OneDrive({ addToast }) {
  const [status, setStatus]       = useState(null);
  const [anno, setAnno]           = useState('');
  const [cartelle, setCartelle]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [loadingAnno, setLoadingAnno] = useState(false);
  const [search, setSearch]       = useState('');
  const [selected, setSelected]   = useState(new Set());
  const [expandedClienti, setExpandedClienti] = useState(new Set());
  const [preview, setPreview]     = useState(null);
  const [showEmail, setShowEmail] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncStato, setSyncStato] = useState(null);

  useEffect(() => {
    fetch('/api/drive-archivio/stato').then(r=>r.json())
      .then(async j => {
        if (!j.success) return;
        const connesso = j.data.connesso;
        let anni = [];
        if (connesso) {
          const ar = await fetch('/api/drive-archivio/anni');
          const aj = await ar.json();
          anni = (aj.data || []);
        }
        setStatus({
          configurato: connesso,
          percorso: j.data.percorso || 'OneDrive sincronizzato',
          anni: anni.map(a => ({ anno: a, clienti: 0, file: 0 })),
          totale_file: 0,
        });
      })
      .finally(() => setLoading(false));
  }, []);

  const loadAnno = (a) => {
    setAnno(a); setSearch(''); setSelected(new Set());
    setLoadingAnno(true);
    fetch(`/api/drive-archivio/${a}/clienti`).then(r=>r.json())
      .then(async j => {
        if (!j.success) return;
        const clientiList = j.data;
        // Per ogni cliente carica i file
        const result = await Promise.all(clientiList.map(async (cliente) => {
          const fr = await fetch(`/api/drive-archivio/${a}/${encodeURIComponent(cliente)}/files`);
          const fj = await fr.json();
          const files = (fj.data||[]).map(f => ({
            ...f,
            filename: f.percorso,
            url: f.url || `/uploads/${f.percorso}`,
            data: f.modified ? new Date(f.modified).toLocaleDateString('it-IT') : '',
          }));
          // Raggruppa per sottocartella
          const gruppi = {};
          files.forEach(f => {
            const sotto = f.sottocartella || '/';
            if (!gruppi[sotto]) gruppi[sotto] = [];
            gruppi[sotto].push(f);
          });
          return {
            cliente,
            file: files,
            totale: files.length,
            gruppi: Object.entries(gruppi).map(([nome, file]) => ({ nome, file })),
          };
        }));
        setCartelle(result);
      })
      .finally(() => setLoadingAnno(false));
  };

  const toggleFile = (filename) => setSelected(prev => {
    const s = new Set(prev); s.has(filename) ? s.delete(filename) : s.add(filename); return s;
  });

  const toggleCliente = (files) => {
    const allSel = files.every(f => selected.has(f.filename));
    setSelected(prev => {
      const s = new Set(prev);
      files.forEach(f => allSel ? s.delete(f.filename) : s.add(f.filename)); return s;
    });
  };

  const tuttiFile = cartelle.flatMap(c => c.file||[]);
  const cartelleFiltrate = search
    ? cartelle.filter(c => c.cliente.toLowerCase().includes(search.toLowerCase()) ||
        (c.file||[]).some(f => f.nome.toLowerCase().includes(search.toLowerCase())))
    : cartelle;

  const sincronizza = async () => {
    setSyncing(true);
    try {
      const res = await fetch('/api/onedrive/sync', { method: 'POST' });
      const j = await res.json();
      if (j.success) alert('✅ ' + j.data.messaggio);
    } catch(e) {}
    setTimeout(() => setSyncing(false), 3000);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <div className="page-title">📁 Archivio Google Drive</div>
          <div className="page-subtitle">Documenti archiviati su Google Drive per anno e cliente</div>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          {selected.size > 0 && (
            <>
              <span style={{ fontSize:12, color:'var(--accent)', fontWeight:500 }}>
                {selected.size} {selected.size===1?'file':'file'} selezionati
              </span>
              <button className="btn btn-primary" onClick={() => setShowEmail(true)}>
                ✉ Invia per email
              </button>
              <button className="btn btn-sm" style={{ color:'var(--text-faint)' }}
                onClick={() => setSelected(new Set())}>✕ Deseleziona</button>
            </>
          )}
        </div>
      </div>

      {/* Status */}
      <div className="card" style={{ marginBottom:20 }}>
        <div className="card-body" style={{ display:'flex', alignItems:'center', gap:20, flexWrap:'wrap' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ width:12, height:12, borderRadius:'50%',
              background: status?.configurato ? 'var(--c-green)' : 'var(--c-red)' }} />
            <span style={{ fontSize:13, fontWeight:500 }}>
              {status?.configurato ? 'OneDrive collegato' : 'Cartella non trovata'}
            </span>
          </div>
          <div style={{ fontSize:12, color:'var(--text-faint)', fontFamily:'monospace' }}>
            {status?.percorso}
          </div>
          <div style={{display:'flex', flexDirection:'column', gap:4, alignItems:'flex-end'}}>
            <button className="btn btn-sm btn-primary" onClick={sincronizza} disabled={syncing || syncStato?.inCorso}>
              {syncing || syncStato?.inCorso ? '⏳ Sincronizzazione in corso…' : '🔄 Sincronizza ora'}
            </button>
            {syncStato?.ultimaSync && (
              <span style={{fontSize:11, color:'var(--text-faint)'}}>
                Ultima sync: {syncStato.ultimaSync}
              </span>
            )}
          </div>
          {status?.configurato && (
            <>
              <div className="kpi-card" style={{ minWidth:100, padding:'8px 16px' }}>
                <div className="kpi-label">Anni</div>
                <div className="kpi-value" style={{ fontSize:20 }}>{status.anni.length}</div>
              </div>
              <div className="kpi-card" style={{ minWidth:100, padding:'8px 16px' }}>
                <div className="kpi-label">File totali</div>
                <div className="kpi-value" style={{ fontSize:20 }}>{status.totale_file}</div>
              </div>
            </>
          )}
        </div>
      </div>

      {!status?.configurato ? (
        <div className="card"><div className="card-body">
          <div className="empty-state">
            <div className="empty-state-icon">📂</div>
            <div className="empty-state-title">Cartella OneDrive non trovata</div>
            <div style={{ fontSize:13, color:'var(--text-faint)', marginTop:8 }}>
              Verifica il percorso in <code>backend/onedrive.config.js</code>
            </div>
          </div>
        </div></div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'200px 1fr', gap:20, alignItems:'start' }}>

          {/* Sidebar anni */}
          <div className="card">
            <div className="card-header"><span className="card-title">Anno</span></div>
            {status.anni.length === 0 ? (
              <div style={{ padding:'16px', fontSize:13, color:'var(--text-faint)', textAlign:'center' }}>Nessun documento</div>
            ) : status.anni.map(a => (
              <div key={a.anno} onClick={() => loadAnno(a.anno)} style={{
                padding:'10px 16px', cursor:'pointer', borderBottom:'1px solid var(--border)',
                background: anno===a.anno ? 'var(--accent-light)' : undefined,
                borderLeft: anno===a.anno ? '3px solid var(--accent)' : '3px solid transparent',
              }}>
                <div style={{ fontWeight:600, fontSize:14, color:anno===a.anno?'var(--accent)':'var(--text)' }}>{a.anno}</div>
                <div style={{ fontSize:11, color:'var(--text-faint)', marginTop:2 }}>
                  {a.clienti} clienti · {a.file} file
                </div>
              </div>
            ))}
          </div>

          {/* Contenuto anno */}
          <div>
            {!anno ? (
              <div className="card"><div className="empty-state" style={{ padding:'60px 0' }}>
                <div className="empty-state-icon">📅</div>
                <div className="empty-state-title">Seleziona un anno</div>
              </div></div>
            ) : loadingAnno ? <LoadingSpinner /> : (
              <>
                {/* Toolbar */}
                <div style={{ display:'flex', gap:10, marginBottom:14, alignItems:'center' }}>
                  <div className="search-box" style={{ flex:1 }}>
                    <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                      <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5"/>
                      <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <input placeholder="Cerca cliente o documento…" value={search} onChange={e=>setSearch(e.target.value)} />
                  </div>
                  <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, cursor:'pointer', color:'var(--text-muted)', whiteSpace:'nowrap' }}>
                    <input type="checkbox"
                      checked={tuttiFile.length>0 && tuttiFile.every(f=>selected.has(f.filename))}
                      onChange={() => {
                        const allSel = tuttiFile.every(f=>selected.has(f.filename));
                        setSelected(allSel ? new Set() : new Set(tuttiFile.map(f=>f.filename)));
                      }}
                      style={{ accentColor:'var(--accent)', cursor:'pointer' }} />
                    Seleziona tutti
                  </label>
                  <span style={{ fontSize:12, color:'var(--text-faint)' }}>{cartelleFiltrate.length} clienti</span>
                </div>

                {cartelleFiltrate.length === 0 ? (
                  <div className="card"><div className="empty-state">
                    <div className="empty-state-icon">📂</div>
                    <div className="empty-state-title">Nessun documento per {anno}</div>
                  </div></div>
                ) : (
                  <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', overflow:'hidden' }}>
                    {cartelleFiltrate.map((cl, ci) => {
                      const isExp   = expandedClienti.has(cl.cliente);
                      const allSel  = (cl.file||[]).every(f=>selected.has(f.filename));
                      const someSel = (cl.file||[]).some(f=>selected.has(f.filename));
                      const nSel    = (cl.file||[]).filter(f=>selected.has(f.filename)).length;
                      return (
                        <div key={cl.cliente} style={{ borderBottom: ci < cartelleFiltrate.length-1 ? '1px solid var(--border)' : 'none' }}>
                          {/* Riga cliente compatta */}
                          <div style={{ display:'flex', alignItems:'center', gap:10, padding:'9px 14px',
                            background: isExp ? 'var(--accent-light)' : 'var(--surface)',
                            cursor:'pointer', transition:'background 0.1s' }}
                            onClick={() => setExpandedClienti(p => {
                              const n = new Set(p);
                              n.has(cl.cliente) ? n.delete(cl.cliente) : n.add(cl.cliente);
                              return n;
                            })}>
                            <span style={{ fontSize:11, color:'var(--text-faint)', width:14, textAlign:'center' }}>{isExp ? '▾' : '▸'}</span>
                            <input type="checkbox" checked={allSel}
                              ref={el => { if(el) el.indeterminate = someSel && !allSel; }}
                              onChange={e => { e.stopPropagation(); toggleCliente(cl.file||[]); }}
                              onClick={e => e.stopPropagation()}
                              style={{ accentColor:'var(--accent)', cursor:'pointer', width:14, height:14 }} />
                            <span style={{ fontSize:13, fontWeight:600, flex:1 }}>📁 {cl.cliente}</span>
                            <span style={{ fontSize:11, color:'var(--text-faint)' }}>{cl.totale||0} file</span>
                            {nSel > 0 && <span style={{ fontSize:11, color:'var(--accent)', fontWeight:600, marginLeft:6 }}>· {nSel} sel.</span>}
                          </div>
                          {/* Contenuto espanso */}
                          {isExp && (
                            <div style={{ padding:'12px 16px 14px 42px', background:'var(--bg)', borderTop:'1px solid var(--border)' }}>
                              {(cl.gruppi||[{nome:'/', file:cl.file||[]}]).map((gruppo, gi) => (
                                <div key={gi} style={{ marginBottom: gi < (cl.gruppi||[]).length-1 ? 16 : 0 }}>
                                  {gruppo.nome && gruppo.nome !== '/' && gruppo.nome !== cl.cliente && (
                                    <div style={{ fontSize:11, fontWeight:600, color:'var(--text-faint)',
                                      textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:10,
                                      display:'flex', alignItems:'center', gap:6, paddingBottom:6,
                                      borderBottom:'1px solid var(--border)' }}>
                                      <span>📁</span>{gruppo.nome.split('/').pop()}
                                    </div>
                                  )}
                                  <div style={{ display:'flex', flexWrap:'wrap', gap:10 }}>
                                    {gruppo.file.map((f, i) => (
                                      <FileCard key={i} f={f}
                                        isSel={selected.has(f.filename)}
                                        onToggle={() => toggleFile(f.filename)}
                                        onPreview={() => setPreview(f)} />
                                    ))}
                                  </div>
                                </div>
                              ))}
                              {(!cl.file||cl.file.length===0) && (
                                <span style={{ fontSize:12, color:'var(--text-faint)' }}>Cartella vuota</span>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* Anteprima file */}
      {preview && <PreviewModal file={preview} onClose={() => setPreview(null)} />}

      {/* Modal email */}
      {showEmail && (
        <EmailModal files={[...selected]} cartelle={cartelle}
          onClose={() => setShowEmail(false)} addToast={addToast} />
      )}
    </div>
  );
}

// ─── MODAL EMAIL ──────────────────────────────────────────────────────────────
function EmailModal({ files, cartelle, onClose, addToast }) {
  const [dest, setDest]       = useState('');
  const [oggetto, setOggetto] = useState('Documenti da Studio SP');
  const [testo, setTesto]     = useState('Gentile Cliente,\n\nIn allegato i documenti richiesti.\n\nCordiali saluti,\nStudio SP');
  const [sending, setSending] = useState(false);

  const nomePulito = (f) => f.split('/').pop().replace(/^\d+_/,'');
  const ext = (f) => f.split('.').pop().toLowerCase();

  const handleSend = async () => {
    if (!dest.trim()) { addToast('Inserisci il destinatario','error'); return; }
    setSending(true);
    try {
      const fd = new FormData();
      fd.append('destinatario', dest);
      fd.append('oggetto', oggetto);
      fd.append('testo', testo);
      files.forEach(f => fd.append('files', f));
      const res  = await fetch('/api/onedrive/invia-email', { method:'POST', body:fd });
      const json = await res.json();
      if (!json.success) throw new Error(json.error);
      addToast(`✅ Email inviata con ${json.data.allegati} allegati`, 'success');
      onClose();
    } catch(e) { addToast(e.message,'error'); }
    finally { setSending(false); }
  };

  return (
    <Modal title="✉ Invia documenti per email" onClose={onClose} size="md">
      <div style={{ marginBottom:16 }}>
        <div style={{ fontSize:12, fontWeight:500, color:'var(--text-muted)', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.4px' }}>
          {files.length} {files.length===1?'allegato':'allegati'}
        </div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
          {files.map((f,i) => (
            <span key={i} style={{ display:'flex', alignItems:'center', gap:6, padding:'4px 10px',
              background:'var(--accent-light)', borderRadius:20, fontSize:12, color:'var(--accent)' }}>
              <FileIcon ext={ext(nomePulito(f))} size={20} />
              {nomePulito(f)}
            </span>
          ))}
        </div>
      </div>
      <div className="form-grid">
        <div className="form-group form-full">
          <label className="form-label">Destinatario *</label>
          <input className="form-control" type="email" value={dest}
            onChange={e=>setDest(e.target.value)} placeholder="email@cliente.it" autoFocus />
        </div>
        <div className="form-group form-full">
          <label className="form-label">Oggetto</label>
          <input className="form-control" value={oggetto} onChange={e=>setOggetto(e.target.value)} />
        </div>
        <div className="form-group form-full">
          <label className="form-label">Testo</label>
          <textarea className="form-control" value={testo} onChange={e=>setTesto(e.target.value)} rows={5} />
        </div>
      </div>
      <div className="modal-footer" style={{ padding:'16px 0 0', borderTop:'1px solid var(--border)', marginTop:16 }}>
        <button className="btn" onClick={onClose}>Annulla</button>
        <button className="btn btn-primary" onClick={handleSend} disabled={sending||!dest.trim()}>
          {sending ? '⏳ Invio…' : `✉ Invia ${files.length} allegati`}
        </button>
      </div>
    </Modal>
  );
}
